import { useCallback } from 'react';
import { useMutateDeleteWaitingList } from '../../../query/waitingList';
import { useWaitingListMemberId } from './useWaitingListMemberId';
import { successToast } from '../../../utils/toast';
import { useCommonTranslation } from '../../i18n/useCommonTranslation';

export const useDeleteWaitingList = () => {
  const { t } = useCommonTranslation();
  const memberId = useWaitingListMemberId();

  const { mutate, isLoading } = useMutateDeleteWaitingList({
    onSuccess: () => {
      successToast(t('waiting-list-delete-successful'));
    },
  });
  const deleteWaitingList = useCallback(() => {
    mutate({
      memberId: memberId,
    });
  }, [mutate, memberId]);
  return {
    deleteWaitingList,
    isLoading,
  };
};
